import { Star, StarHalf } from "lucide-react"

const Stars = (props) => {
  const starsArray = []
  let iconSize = 16
  if (props.size === "xs") iconSize = 12
  else if (props.size === "sm") iconSize = 14
  else if (props.size === "md") iconSize = 16
  else if (props.size === "lg") iconSize = 20

  for (let i = 1; i <= 5; i++) {
    i <= props.stars
      ? starsArray.push(
        <Star
          key={i}
          size={iconSize}
          className={`${props.color ? props.color : "text-warning"} d-inline-block align-middle`}
          fill="currentColor"
        />
      )
      : (i - 0.5) === props.stars
        ? starsArray.push(
          <StarHalf
            key={i}
            size={iconSize}
            className={`${props.color ? props.color : "text-warning"} d-inline-block align-middle`}
            fill="currentColor"
          />
        )
        : starsArray.push(
          <Star
            key={i}
            size={iconSize}
            className={`${props.color ? props.color : "text-primary"} d-inline-block align-middle`}
          />
        )
  }
  return starsArray
}

export default Stars
